import { GradesTypes } from './types';

const { ADD_SUBJECT_SELECTED, ADD_TOTAL_AVERAGE, ADD_GRADE_TYPE_SELECTED } = GradesTypes;

interface GradesState {
  subjectSelected: [];
  gradeTypeSelected: [];
  totalAverage: [];
}

export const initialState: GradesState = {
  subjectSelected: [],
  totalAverage: [],
  gradeTypeSelected: [],
};

// eslint-disable-next-line default-param-last
const gradesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ADD_SUBJECT_SELECTED: {
      return {
        ...state,
        subjectSelected: action.payload,
      };
    }
    case ADD_GRADE_TYPE_SELECTED: {
      return {
        ...state,
        gradeTypeSelected: action.payload,
      };
    }
    case ADD_TOTAL_AVERAGE: {
      return {
        ...state,
        totalAverage: [...state.totalAverage, action.payload],
      };
    }
    default: {
      return state;
    }
  }
};

export default gradesReducer;
